

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Result } from '@/models/dynamiclist';
import { Getter } from 'vuex-class';

@Component({})
export default class ResultComponent extends Vue {
    @Prop({ required: true })
    public result!: Result;

    @Getter('searchFilterQuery')
    private searchFilterQuery!: string;

    public highlight(value: string): string {
        if (!this.searchFilterQuery) {
            return value;
        }

        if (value) {
            const index = value.toLowerCase().indexOf(this.searchFilterQuery.toLowerCase());

            if (index >= 0) {
                value = value.substring(0, index)
                    + '<span class=\'highlight\'>' + value.substring(index, index + this.searchFilterQuery.length)
                    + '</span>' + value.substring(index + this.searchFilterQuery.length);
            }
        }

        return value;
    }
}
